import React from 'react';
import { useStore, Responsible } from '../../store/useStore';
import { Input, Select, AvatarUpload } from '../ui';
import { Users, Trash2, Plus } from 'lucide-react';

export function M2_Responsibles() {
  const { responsibles, setResponsibles } = useStore();

  const handleAdd = () => {
    setResponsibles([
      ...responsibles,
      { id: Date.now().toString(), area: 'Outro', nome: '', cargo: '', telefone: '', whatsapp: '', email: '' }
    ]);
  };

  const handleRemove = (id: string) => {
    setResponsibles(responsibles.filter((r) => r.id !== id));
  };

  const handleChange = (id: string, field: keyof Responsible, value: string) => {
    setResponsibles(
      responsibles.map((r) => (r.id === id ? { ...r, [field]: value } : r))
    );
  };

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-display font-semibold text-gray-900">Responsáveis</h2>
          <p className="text-sm text-gray-500 mt-1">Pontos de contato chave dentro do cliente.</p>
        </div>
        <button
          onClick={handleAdd}
          className="flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors shadow-sm"
        >
          <Plus size={16} /> Adicionar Contato
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {responsibles.map((resp) => (
          <div key={resp.id} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden group">
            <div className="p-4 border-b border-gray-100 bg-gray-50/50 flex flex-col gap-3">
               <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                     <Users size={18} className="text-gray-500" />
                     <span className="font-semibold text-gray-900 truncate max-w-[150px]">{resp.nome || 'Novo Contato'}</span>
                  </div>
                  {responsibles.length > 1 && (
                     <button onClick={() => handleRemove(resp.id)} className="text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity">
                         <Trash2 size={16} />
                     </button>
                  )}
               </div>
               <Select 
                 options={[{label: 'Proprietário', value: 'Proprietário'}, {label: 'Marketing', value: 'Marketing'}, {label: 'Comercial', value: 'Comercial'}, {label: 'Financeiro', value: 'Financeiro'}, {label: 'Outro', value: 'Outro'}]}
                 value={resp.area}
                 onChange={(e) => handleChange(resp.id, 'area', e.target.value)}
                 className="h-8 py-1 text-xs"
               />
            </div>
            <div className="p-5 space-y-4">
              <div className="pb-2">
                <AvatarUpload 
                    label="Foto / Avatar" 
                    onChange={(file) => handleChange(resp.id, 'avatar', file as any)}
                />
              </div>
              <Input label="Nome Completo" value={resp.nome} onChange={(e) => handleChange(resp.id, 'nome', e.target.value)} placeholder="Nome do contato" />
              <Input label="Cargo" value={resp.cargo} onChange={(e) => handleChange(resp.id, 'cargo', e.target.value)} placeholder="Ex: Diretor de Vendas" />
              <div className="grid grid-cols-2 gap-3">
                  <Input label="Telefone" value={resp.telefone} onChange={(e) => handleChange(resp.id, 'telefone', e.target.value)} placeholder="(00)" />
                  <Input label="WhatsApp" value={resp.whatsapp} onChange={(e) => handleChange(resp.id, 'whatsapp', e.target.value)} placeholder="(00) 9" />
              </div>
              <Input label="E-mail" type="email" value={resp.email} onChange={(e) => handleChange(resp.id, 'email', e.target.value)} placeholder="email@empresa.com" />
            </div>
          </div>
        ))}
        
        <button
          onClick={handleAdd}
          className="border-2 border-dashed border-gray-200 rounded-xl bg-gray-50/50 hover:bg-gray-50 hover:border-gray-300 transition-colors flex items-center justify-center min-h-[400px] flex-col gap-3 text-gray-500 hover:text-gray-900"
        >
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100 mb-2">
            <Plus size={20} />
          </div>
          <span className="font-medium text-sm">Adicionar Contato</span>
        </button>
      </div>
    </div>
  );
}
